import { __decorate } from "tslib";
import { AccessGuard, accessGuardData, provideFeatureAddonRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let MpfDocentsFrontendManagementFeature = /*#__PURE__*/(() => {
  let MpfDocentsFrontendManagementFeature = class MpfDocentsFrontendManagementFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/docents/frontend-management","featureId":"mpf-docents"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        managementToolbar: {
          basePath: 'management/docent',
          items: [{
            label: 'Dozent',
            routerLink: '',
            simpleAbilityCheck: {
              allow: ["Feature.mpf-docents.Manage"]
            },
            priority: 5,
            items: [{
              label: 'Infoseite',
              icon: 'id-card',
              routerLink: 'profile',
              simpleAbilityCheck: {
                allow: ["Feature.mpf-docents.Manage"]
              },
              priority: 5
            }, {
              label: 'Blog',
              icon: 'marker',
              routerLink: 'blog',
              simpleAbilityCheck: {
                allow: ["Feature.mpf-docents.Manage"]
              },
              priority: 5
            }]
          }]
        }
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfDocentsFrontendManagementFeature_BaseFactory;
        return function MpfDocentsFrontendManagementFeature_Factory(__ngFactoryType__) {
          return (ɵMpfDocentsFrontendManagementFeature_BaseFactory || (ɵMpfDocentsFrontendManagementFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfDocentsFrontendManagementFeature)))(__ngFactoryType__ || MpfDocentsFrontendManagementFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfDocentsFrontendManagementFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideFeatureAddonRoutes([{
          useAddonSlot: 'management',
          path: 'docent',
          canActivate: [AccessGuard],
          data: {
            ...accessGuardData({
              allow: ["Feature.mpf-docents.Manage"]
            })
          },
          loadChildren: () => import('./docents-management.module').then(m => m.DocentsFrontendManagementModule)
        }])]
      });
    }
  };
  MpfDocentsFrontendManagementFeature = __decorate([ClassName("MpfDocentsFrontendManagementFeature")], MpfDocentsFrontendManagementFeature);
  return MpfDocentsFrontendManagementFeature;
})();
export { MpfDocentsFrontendManagementFeature };